import request from '@/utils/request';

export function login(res) {
  return request({
    url: '/enterprise-server/login',
    method: 'post',
    data: {
      username: res.username,
      password: res.password,
      captchaAnswer: res.captcha_code,
      captchaID: res.captcha_id
    }
  });
}
// Rainbond登录
export function rainbondLogin(data) {
  return request({
    url: '/enterprise-server/sms/login',
    method: 'POST',
    data
  });
}

export function getCheckEname(params) {
  return request({
    url: '/enterprise-server/check/ename',
    method: 'get',
    params
  });
}

export function getCheckPhone(params) {
  return request({
    url: '/enterprise-server/check/phone',
    method: 'get',
    params
  });
}
export function getCheckEmail(params) {
  return request({
    url: '/enterprise-server/check/email',
    method: 'get',
    params
  });
}

export function postCheckMaktet(data) {
  return request({
    url: '/app-server/markets/checkname',
    method: 'post',
    data
  });
}

export function getCheckDomain(params) {
  return request({
    url: '/enterprise-server/check/domain',
    method: 'get',
    params
  });
}

export function getUserName() {
  return request({
    url: '/admin/info',
    method: 'get'
  });
}

export function postRegist(res) {
  return request({
    url: '/enterprise-server/user/register',
    method: 'post',
    data: {
      ename: res.ename,
      domain: res.domain,
      realName: res.realName,
      email: res.email,
      phone: res.phone,
      phoneCode: res.phoneCode,
      password: res.password
    }
  });
}

export function postSendsms(res) {
  return request({
    url: '/enterprise-server/phone-code',
    method: 'post',
    data: {
      phoneNbr: res.phone_nbr,
      captchaID: res.captcha_id,
      captchaAnswer: res.captcha_answer
    }
  });
}

export function retrievePassword(res) {
  return request({
    url: '/ajax/user/chpassauth',
    method: 'post',
    data: {
      phone_nbr: res.phone_nbr,
      vcode: res.vcode
    }
  });
}

export function modifyPassword(res) {
  return request({
    url: '/enterprise-server/resetpassword',
    method: 'post',
    data: {
      phoneNbr: res.phoneNbr,
      phoneCode: res.phoneCode,
      newPassword: res.newPassword
    }
  });
}

export function getVerification() {
  return request({
    url: '/enterprise-server/captcha',
    method: 'get'
  });
}

export function getIsVerification() {
  return request({
    url: '/ajax/configs',
    method: 'get'
  });
}

export function logout() {
  return request({
    url: '/enterprise-server/logout',
    method: 'DELETE'
  });
}



// WEBPACK FOOTER //
// ./src/api/login.js